"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nips = void 0;
var Nips;
(function (Nips) {
    Nips[Nips["Search"] = 50] = "Search";
})(Nips = exports.Nips || (exports.Nips = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmlwcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9uaXBzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksSUFFWDtBQUZELFdBQVksSUFBSTtJQUNkLG9DQUFXLENBQUE7QUFDYixDQUFDLEVBRlcsSUFBSSxHQUFKLFlBQUksS0FBSixZQUFJLFFBRWYifQ==